import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import type { Moment } from "@msuite/utils/date";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useDailyStatic(moment: Moment) {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	const query = useQuery({
		queryKey: ["daily", moment.dbWeek()],
		queryFn: async () => {
			const response = await client.plan[":week"].$get({
				param: {
					week: moment.dbWeek(),
				},
			});
			const data = await responseHandler(response);
			return data;
		},
		staleTime: 1_000 * 60 * 10,
		refetchInterval: 1_000 * 60,
		// The endpoint gates on `read Plan`, which the base set holds but a role may narrow away.
		// The command screen is reachable without it, so the request is not sent rather than
		// answered with a refusal and a toast every minute the interval fires.
		enabled: citadel?.can("read", "Plan", { orgId: citadel.orgId }) === true,
	});

	function getPlans() {
		const date = moment.db();
		return guardArray((query.data?.plans.find((plan) => plan.date === date) ?? null)?.plans);
	}

	return {
		...query,
		plans: getPlans(),
	};
}
